<template>
  <div
    class="dui-option"
    :data-is-label="isLabel"
    :data-text="text"
    :data-value="value"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    isLabel: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      required: true,
    },
    value: {
      type: [ Number, String ],
      default: null,
    },
  },
};
</script>
